class ProductCardColorSwatches extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        // Cache DOM elements and bind methods
        this.productCard = this.closest('.card-wrapper');
        if (!this.productCard) return;

        this.productImage = this.productCard.querySelector('.card__media img');
        this.productLinks = this.productCard.querySelectorAll('a.full-unstyled-link');
        this.buttons = this.querySelectorAll('.color-swatch__button');
        
        // Add CSS for smooth transitions
        if (this.productImage) {
            Object.assign(this.productImage.style, {
                transition: 'opacity 0.3s ease-in-out',
                willChange: 'opacity' // Optimize performance
            });
        }

        // Preload images for instant switching
        this.preloadImages();

        // Use event delegation for better performance
        this.addEventListener('click', this.handleClick.bind(this));
    }

    preloadImages() {
        // Create hidden image elements to preload
        const images = new Set();
        this.buttons.forEach(button => {
            const imageUrl = button.dataset.image;
            if (imageUrl && !images.has(imageUrl)) {
                const img = new Image();
                img.src = imageUrl;
                images.add(imageUrl);
            }
        });
    }

    handleClick(event) {
        const button = event.target.closest('.color-swatch__button');
        if (!button || !this.productImage) return;

        // Debounce rapid clicks
        if (this.isTransitioning) return;
        this.isTransitioning = true;

        // Update active state
        this.buttons.forEach(btn => btn.classList.remove('color-swatch__button--active'));
        button.classList.add('color-swatch__button--active');

        // Update image with fade effect
        this.updateImage(button.dataset.image);

        // Update product links
        this.updateLinks(button.dataset.variantId);
    }

    async updateImage(newImageUrl) {
        // Start fade out
        this.productImage.style.opacity = '0';

        // Prepare new image data
        const srcset = this.generateSrcset(newImageUrl);
        
        // Wait for fade out to complete
        await new Promise(resolve => setTimeout(resolve, 300));

        // Update image sources
        this.productImage.srcset = srcset;
        this.productImage.src = newImageUrl;

        // Force browser to recognize the new image
        this.productImage.complete ? this.fadeInImage() : 
            this.productImage.onload = () => this.fadeInImage();
    }

    fadeInImage() {
        requestAnimationFrame(() => {
            this.productImage.style.opacity = '1';
            this.isTransitioning = false;
        });
    }

    generateSrcset(baseUrl) {
        const widths = [165, 360, 533, 720, 940, 1066];
        return widths
            .map(width => {
                const url = baseUrl.replace('width=533', `width=${width}`);
                return `${url} ${width}w`;
            })
            .join(',');
    }

    updateLinks(variantId) {
        this.productLinks.forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set('variant', variantId);
            link.href = url.toString();
        });
    }
}

if (!customElements.get('product-card-color-swatches')) {
    customElements.define('product-card-color-swatches', ProductCardColorSwatches);
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const mediaElement = document.querySelector(".card__media");
    if (!mediaElement) return; // Exit if media element is not found

    const mediaHeight = mediaElement.offsetWidth;
    console.log(mediaHeight);
    const newTop = mediaHeight + 26;

    document.querySelectorAll(".quick-add").forEach((el) => {
      el.style.top = `${newTop}px`;
    });
  }, 100);
});
